"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioVolumeControl = exports.useComponentStyles = void 0;
var React = __importStar(require("react"));
var Slider_1 = __importDefault(require("@material-ui/core/Slider"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var VolumeOff_1 = __importDefault(require("@material-ui/icons/VolumeOff"));
var VolumeUp_1 = __importDefault(require("@material-ui/icons/VolumeUp"));
var classnames_1 = __importDefault(require("classnames"));
var player_1 = __importDefault(require("./state/player"));
exports.useComponentStyles = makeStyles_1.default(function (theme) {
    var _a;
    return {
        sliderContainer: {
            flex: '1 1 auto',
        },
        slider: function (props) { return ({
            color: props.playerColors.active,
        }); },
        commonContainer: {
            flex: '0 0 auto',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        icon: function (props) { return ({
            color: props.playerColors.active,
            '&:hover': {
                color: props.playerColors.hover,
            },
        }); },
        volumeIconContainer: {
            position: 'relative',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        volumeControlContainer: (_a = {
                position: 'absolute',
                display: 'none',
                zIndex: 10
            },
            _a[theme.breakpoints.up('sm')] = {
                display: 'flex',
                height: '60px',
            },
            _a.padding = '10px 5px',
            _a),
    };
});
var AudioVolumeControl = function (_a) {
    var _b = _a.muted, muted = _b === void 0 ? null : _b, muteAudio = _a.muteAudio, unmuteAudio = _a.unmuteAudio, _c = _a.classNames, classNames = _c === void 0 ? {} : _c, volume = _a.volume, changeAudioVolume = _a.changeAudioVolume, _d = _a.icons, icons = _d === void 0 ? {} : _d, playerColors = _a.playerColors;
    var classes = exports.useComponentStyles({ playerColors: playerColors });
    var _e = icons.VolumeUpIcon, VolumeUpIcon = _e === void 0 ? VolumeUp_1.default : _e, _f = icons.VolumeOffIcon, VolumeOffIcon = _f === void 0 ? VolumeOff_1.default : _f;
    var handleVolumeChange = function (event, value) {
        changeAudioVolume(value);
    };
    var _g = React.useState(false), volumeSlider = _g[0], openVolumeSlider = _g[1];
    var toggleVolumeSlider = function (value) { return function () {
        openVolumeSlider(value);
    }; };
    return (React.createElement(Grid_1.default, { item: true, className: classnames_1.default(classes.commonContainer, classes.volumeIconContainer), onMouseEnter: toggleVolumeSlider(true), onMouseLeave: toggleVolumeSlider(false) },
        volume.status === player_1.default.VOLUME.STATUS.UNMUTE ? (React.createElement(VolumeUpIcon, { fontSize: "large", className: classnames_1.default(classes.icon, classNames.volumeIcon), onClick: typeof muted !== 'boolean' ? muteAudio : function () { } })) : (React.createElement(VolumeOffIcon, { fontSize: "large", className: classnames_1.default(classes.icon, classNames.volumeIcon), onClick: typeof muted !== 'boolean' ? unmuteAudio : function () { } })),
        volumeSlider && (React.createElement(Paper_1.default, { className: classnames_1.default(classes.volumeControlContainer, classNames.volumeSliderContainer) },
            React.createElement(Slider_1.default, { orientation: "vertical", "aria-labelledby": "volume-control", value: volume.value, defaultValue: player_1.default.VOLUME.DEFAULT_VALUE, onChange: handleVolumeChange, className: classnames_1.default(classes.slider, classNames.volumeSlider) })))));
};
exports.AudioVolumeControl = AudioVolumeControl;
exports.default = React.memo(exports.AudioVolumeControl);
//# sourceMappingURL=AudioVolumeControl.js.map